/* Cartes produits v2 (23/09/2026) — défilement des images de la carte au survol.
   Ordinateur avec souris seulement. Toutes les 1,5 s : image suivante (4 max),
   points indicateurs (.bn-dots) ; images 3-4 chargées au premier survol ;
   à la sortie, retour à l'image 1 et arrêt. Délégation sur mouseover : couvre
   aussi les cartes injectées après coup (filtres, recommandations, recherche). */
(function () {
  if (window.bnCardsInit) return;
  window.bnCardsInit = true;
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
  var INTERVAL = 1500;

  function setup(wrap) {
    var dots = wrap.querySelector('.bn-dots');
    if (!dots) return null;
    var media = dots.parentElement;
    var imgs = media.querySelectorAll(':scope > img');
    var n = Math.min(imgs.length, 4);
    if (n < 3) return null;
    var dot = dots.querySelectorAll('.bn-dot');
    var timer = null, idx = 0, loaded = false;
    function show(i) {
      idx = i;
      media.setAttribute('data-bn-slide', i);
      dot.forEach(function (d, k) { d.classList.toggle('bn-dot--active', k === i); });
    }
    function enter() {
      if (timer) return;
      if (!loaded) {
        loaded = true;
        imgs.forEach(function (im) {
          if (im.dataset.bnSrcset) {
            im.srcset = im.dataset.bnSrcset;
            im.src = im.dataset.bnSrc;
            im.removeAttribute('data-bn-srcset');
            im.removeAttribute('data-bn-src');
          }
        });
      }
      show(1);
      timer = setInterval(function () { show((idx + 1) % n); }, INTERVAL);
    }
    function leave() {
      clearInterval(timer);
      timer = null;
      media.removeAttribute('data-bn-slide');
      dot.forEach(function (d) { d.classList.remove('bn-dot--active'); });
    }
    wrap.addEventListener('mouseenter', enter);
    wrap.addEventListener('mouseleave', leave);
    return enter;
  }

  document.addEventListener('mouseover', function (e) {
    var wrap = e.target.closest && e.target.closest('.card-wrapper.product-card-wrapper');
    if (!wrap || wrap.bnSlides) return;
    wrap.bnSlides = true;
    var enter = setup(wrap);
    if (enter) enter();
  });
})();
